import ContactList from './ContactList';
import AddButton from './ContactListAddButton';
import Header from './ContactListHeader';
import Item from './ContactListItem';
import Subtitle from './ContactListItemSubtitle';

ContactList.Header = Header;
ContactList.Item = Item;
ContactList.Item.Subtitle = Subtitle;
ContactList.AddButton = AddButton;

export default ContactList;
